import { Base } from "./base";

import { addDays } from "date-fns";
import { formatTimestamp } from "../utils/helper";
export class Dashboard extends Base {
  #getURLWithQueryString(endpoint, { room, machine, startTs, stopTs }) {
    const url = new URL(this._getFullURL(endpoint));
    const params = {};
    if (machine) {
      params.machine = machine;
    }
    if (room) {
      params.room = room;
    }
    if (startTs) {
      params["start_ts"] = startTs;
    }
    if (stopTs) {
      let newStop = stopTs;
      if (stopTs === startTs) {
        let date = addDays(new Date(stopTs * 1000), 1);
        newStop = formatTimestamp(date);
      }
      params["stop_ts"] = newStop;
    }
    url.search = new URLSearchParams(params).toString();
    return url;
  }

  /**
   * @description Uptime API function
   * @param {object} filterParams
   * @param {?string} filterParams.machine Comma separated machine names
   * @param {?string} filterParams.startTs Start time in epoch
   * @param {?string} filterParams.stopTs End time in epoch
   * @returns {Promise<Response>}
   */
  uptime(filterParams) {
    const url = this.#getURLWithQueryString("/dashboard/uptime", filterParams);
    return this._secureFetch(url);
  }
  /**
   * @description Uptime API function
   * @param {object} filterParams
   * @param {?string} filterParams.machine Comma separated machine names
   * @param {?string} filterParams.startTs Start time in epoch
   * @param {?string} filterParams.stopTs End time in epoch
   * @returns {Promise<Response>}
   */
  aletStatus(payload) {
    const url = this._getFullURL(`/analytics/alert-status-company`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload: payload,
        method: "POST",
      })
    );
  }
  /**
   * @description Uptime API function
   * @param {object} filterParams
   * @param {?string} filterParams.machine Comma separated machine names
   * @param {?string} filterParams.startTs Start time in epoch
   * @param {?string} filterParams.stopTs End time in epoch
   * @returns {Promise<Response>}
   */
  topMachine(payload) {
    const url = this._getFullURL(`/analytics/top-machine`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload: payload,
        method: "POST",
      })
    );
  }
  /**
   * @description Uptime API function
   * @param {object} filterParams
   * @param {?string} filterParams.machine Comma separated machine names
   * @param {?string} filterParams.startTs Start time in epoch
   * @param {?string} filterParams.stopTs End time in epoch
   * @returns {Promise<Response>}
   */
  aletStatusCompany(payload) {
    const url = this._getFullURL(`/analytics/alert-status-company`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload: payload,
        method: "POST",
      })
    );
  }
  /**
   * @description Uptime API function
   * @param {object} filterParams
   * @param {?string} filterParams.machine Comma separated machine names
   * @param {?string} filterParams.startTs Start time in epoch
   * @param {?string} filterParams.stopTs End time in epoch
   * @returns {Promise<Response>}
   */
  machineHealth(payload) {
    const url = this._getFullURL(`/analytics/machine-health-group`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload: payload,
        method: "POST",
      })
    );
  }
  /**
   * @description Uptime API function
   * @param {object} filterParams
   * @param {?string} filterParams.machine Comma separated machine names
   * @param {?string} filterParams.startTs Start time in epoch
   * @param {?string} filterParams.stopTs End time in epoch
   * @returns {Promise<Response>}
   */
  machineHealthSelf(payload) {
    const url = this._getFullURL(`/analytics/machine-health-self`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload: payload,
        method: "POST",
      })
    );
  }
  requestRelocate(payload) {
    const url = this._getFullURL(`/auth/request_change`);
    return fetch(
        url,
        this._generateRequestBody({
          authentication: true,
          payload: payload,
          method: "POST",
        })
    );
  }
  /**
   * @description Uptime API function
   * @param {object} filterParams
   * @param {?string} filterParams.machine Comma separated machine names
   * @param {?string} filterParams.startTs Start time in epoch
   * @param {?string} filterParams.stopTs End time in epoch
   * @returns {Promise<Response>}
   */
  alertAnalyticCostManpower() {
    const url = this._getFullURL(`/analytics/alert-result-per-company`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload: {},
        method: "POST",
      })
    );
  }

  /**
   * @description Alert Notificagtion API function
   * @param {object} filterParams
   * @param {?string} filterParams.machine Comma separated machine names
   * @param {?string} filterParams.startTs Start time in epoch
   * @param {?string} filterParams.stopTs End time in epoch
   * @returns {Promise<Response>}
   */
  notification(filterParams) {
    const url = this.#getURLWithQueryString(
      "/dashboard/anomaly_notification",
      filterParams
    );
    return this._secureFetch(url);
  }

  /**
   * @description Alert Notificagtion API function
   * @param {object} filterParams
   * @param {?string} filterParams.machine Comma separated machine names
   * @param {?string} filterParams.startTs Start time in epoch
   * @param {?string} filterParams.stopTs End time in epoch
   * @returns {Promise<Response>}
   */
  anomaly_for_gina(filterParams) {
    const url = this.#getURLWithQueryString(
      "/dashboard/anomaly_for_gina",
      filterParams
    );
    return this._secureFetch(url);
  }

  /**
   * @description Health API function
   * @param {object} filterParams
   * @param {?string} filterParams.machine Comma separated machine names
   * @param {?string} filterParams.startTs Start time in epoch
   * @param {?string} filterParams.stopTs End time in epoch
   * @returns {Promise<Response>}
   */
  health(filterParams) {
    const url = this.#getURLWithQueryString("/dashboard/health", filterParams);
    return this._secureFetch(url);
  }

  /**
   * @description Alert count API function
   * @param {object} filterParams
   * @param {?string} filterParams.machine Comma separated machine names
   * @param {?string} filterParams.startTs Start time in epoch
   * @param {?string} filterParams.stopTs End time in epoch
   * @returns {Promise<Response>}
   */
  alertCount(filterParams) {
    const url = this.#getURLWithQueryString(
      "/dashboard/alert_count",
      filterParams
    );
    return fetch(url, this._generateRequestBody({}));
  }

  /**
   * @description Alert List with audio API function
   * @param {object} filterParams
   * @param {?string} filterParams.machine Comma separated machine names
   * @param {?string} filterParams.startTs Start time in epoch
   * @param {?string} filterParams.stopTs End time in epoch
   * @returns {Promise<Response>}
   */
  anomalyPerMachine(filterParams) {
    const url = this.#getURLWithQueryString(
      "/dashboard/anomaly_each_machine",
      filterParams
    );
    return this._secureFetch(url);
  }

  anomalyPerMachineGrey(filterParams) {
    const url = this.#getURLWithQueryString(
      "/dashboard/anomaly_permachine_grey",
      filterParams
    );
    return this._secureFetch(url);
  }

  anomalyAllSublocation(filterParams) {
    const url = this.#getURLWithQueryString(
      "/dashboard/anomaly_all",
      filterParams
    );
    return this._secureFetch(url);
  }

  /**
   * @description Normal List with audio API function
   * @param {object} filterParams
   * @param {?string} filterParams.machine Comma separated machine names
   * @param {?string} filterParams.startTs Start time in epoch
   * @param {?string} filterParams.stopTs End time in epoch
   * @returns {Promise<Response>}
   */
  alertListNormalOnly(filterParams) {
    let url_full = "/dashboard/all_normal_record";
    const url = this.#getURLWithQueryString(url_full, filterParams);
    return this._secureFetch(url);
  }

  /**
   * @description Alert count by machine API function
   * @param {object} filterParams
   * @param {?string} filterParams.machine Comma separated machine names
   * @param {?string} filterParams.startTs Start time in epoch
   * @param {?string} filterParams.stopTs End time in epoch
   * @returns {Promise<Response>}
   */
  alertCountByMachine(filterParams) {
    const url = this.#getURLWithQueryString(
      "/dashboard/alert_count_by_machine",
      filterParams
    );
    return this._secureFetch(url);
  }
  alertPCAPerMachine(filterParams) {
    const url = this.#getURLWithQueryString(
      "/dashboard/alert_pca_by_machine",
      filterParams
    );
    return this._secureFetch(url);
  }

  alertByRoom(filterParams) {
    const url = this.#getURLWithQueryString(
      "/dashboard/alert_by_room",
      filterParams
    );
    return this._secureFetch(url);
  }
  machineUptimeByRoom(filterParams) {
    const url = this.#getURLWithQueryString(
      "/dashboard/machine_uptime_by_room",
      filterParams
    );
    return fetch(url, this._generateRequestBody({}));
  }
  machineHealthByRoom(filterParams) {
    const url = this.#getURLWithQueryString(
      "/dashboard/machine_health_by_room",
      filterParams
    );
    return fetch(url, this._generateRequestBody({}));
  }
}
